import { Form, Formik } from "formik";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { userid, currentTenant, ccountry } from "../../Common/Credentials.js";
import Footer from "../../Component/Footer.js";
import Header from "../../Component/Header.js";
import Menu from "../../Component/Menu.js";
import { Spinner } from "react-bootstrap";
import { TextField } from "@mui/material";
import IfscFetch, { bankifsc, bankres, branchres } from "../../Accounts/Ledgers/IfscFetch.jsx";
import BankServices from "./BankServices.js";

import SearchIcon from "../../images/Icons/search.png";
import TextfieldComponent from "../../Component/TextfieldComponent.jsx";
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";

let ifsccode, branch, bankname
class Addbank extends Component {
  constructor(props) {
    super(props);
    const locationState = this.props.location?.state || {};
    this.state = {
      id: locationState.id ?? -1,
      pagename: locationState.pagename || "Add Bank",
      bankname: "",
      accno: "",
      accname: '',
      branchname: "",
      ifsc: "",
      message: "",
      loader: false,
      err: false,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.ifscClick = this.ifscClick.bind(this)
  }


  ifscClick1() {
    this.setState({ bankname: '' })
    this.setState({ branchname: '' })
    branch = ""
    bankname = ""
  }



  ifscClick = (ifsccode) => {
    this.ifscClick1()
    if (ifsccode !== undefined) {
      if (ifsccode !== null) {
        if (ifsccode !== '') {
          if (ifsccode.length === 11) {
            IfscFetch.setIfsc(ifsccode)

            branch = ''
            bankname = ''
            this.setState({ bankname: bankres, branchname: branchres })
            branch = branchres
            bankname = bankres
          } else {
            this.ifscClick1()
            ifsccode = ""
            branch = ''
            bankname = ''

          }
        }
      }
    }


    //ifsccode=bankifsc
    //}
  }

  onSubmit(values) {
    console.log(this.state.bankname, this.state.accno, this.state.accname, this.state.ifsc, this.state.branchname)
    if (
      this.state.bankname === "" ||
      this.state.accno === "" ||
      this.state.branchname === "" ||
      this.state.ifsc === "" ||
      this.state.accname === ""
    ) {
      this.setState({ err: true });
    } else {
      this.setState({ loader: true });
      let data = {
        id: this.state.id,
        bankname: this.state.bankname,
        accno: this.state.accno,
        accname: this.state.accname,
        branchname: this.state.branchname,
        ifsc: this.state.ifsc,
        tenantid: currentTenant,
        createdBy: userid,
      };
      if (this.state.id === -1) {
        BankServices.addBank(data)
          .then(() => this.props.navigate("/bank"))
          .catch((e) => {
            if (e.response.data.error === "Unauthorized") {
              alert("Your Session is Lost: Please login Back to resume");
              this.props.navigate(`/`);
            }
            this.setState({ message: e.response.data.message, loader: false });
          });
      } else {
        BankServices.updateBank(data)
          .then(() => this.props.navigate("/bank"))
          .catch((e) => {
            if (e.response.data.error === "Unauthorized") {
              alert("Your Session is Lost: Please login Back to resume");
              this.props.navigate(`/`);
            }
            this.setState({ message: e.response.data.message, loader: false });
          });
      }
    }
  }

  componentDidMount() {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }
    this.ifscClick1()

    const bankId = this.state.id > 0 ? this.state.id : this.props.location?.state?.id;
    if (bankId > 0) {
      BankServices.Getbankbyid(bankId).then((res) => {
        this.setState({
          id: res.data.id,
          bankname: res.data.bankname,
          accno: res.data.accno,
          accname: res.data.accname,
          branchname: res.data.branchname,
          ifsc: res.data.ifsc,
        })
      })
    }
  }

  validate(values) {
    let errors = {};
    if (!values.bankname) {
      errors.bankname = "Please enter bank name";
    }
    if (!values.accno) {
      errors.accno = "Please enter account number";
    }
    if (!values.branchname) {
      errors.branchname = "Please enter branchname number";
    }
    if (!values.ifsc) {
      errors.ifsc = "Please enter bank ifsc code";
    }


    return errors;
  }

  render() {
    let { id, bankname, accno, accname, branchname, ifsc, err } = this.state;

    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
          <div className="UI-container">
            <div className={`UI-header`}>
              <Breadcrumb breadcrumbs={[{ name: "Home", path: "/masters" }, { name: "Bank", path: "/bank" }, { name: this.state.pagename, path: null }]} />
            </div>
            <div className="UI-form-card">
              <Formik
                initialValues={{ id, bankname, accno, accname, branchname, ifsc, err }}
                onSubmit={this.onSubmit}
                validateOnChange={false}
                validate={this.validate}
                enableReinitialize={true}
              >
                {({ errors }) => (
                  <Form autoComplete="off">
                    <div className="form-row mb-3">

                      <fieldset className={ccountry === "India" ? "col-md-3" : "col-md-4"}>
                        <TextfieldComponent
                          className="form-control"
                          type="text"
                          name="ifsc"
                          label={`Enter ${ccountry === "India" ? "IFSC" : " BANK/IBAN/SWIFT"} code`}
                          value={this.state.ifsc}
                          onChange={(e) => {
                            this.setState({ ifsc: e.target.value, message: "", err: false })
                            if (ccountry === "India") {
                              e.target.value.length === 11 ? this.ifscClick(e.target.value) : this.ifscClick1()
                            }
                          }
                          }
                          error={errors?.ifsc || (err || (ccountry === "India" && this.state.ifsc.length !== 11 && this.state.ifsc.length !== 0))}
                          helperText={errors?.ifsc || (err ? "IFSC is Required" : (ccountry === "India" && this.state.ifsc.length !== 11 && this.state.ifsc.length !== 0) ? "Invalid" : '')}
                          variant="standard"
                        />
                      </fieldset>
                      {/* <fieldset className=" col-md-1">
                      <button className="btn buttonColour btn-sm mt-3" type="button" onClick={()=>this.state.bankname!==''?this.ifscClick1():this.ifscClick(this.state.ifsc)}>{this.state.bankname!==''?"Clear":"Check"} </button>
                      </fieldset> */}

                      {ccountry === "India" && <fieldset className=" col-md-1">
                        <button
                          className="tw-h-full tw-mt-1.5 d-flex align-items-center justify-content-center"
                          type="button"
                          onClick={() => this.state.bankname !== '' ? this.ifscClick1() : this.ifscClick(this.state.ifsc)}
                          style={{}}
                        >
                          <img
                            src={SearchIcon}
                            alt="Search"
                            style={{ width: "1.6rem", height: "1.6rem" }}
                          />
                        </button>
                      </fieldset>}


                      <fieldset className=" col-md-4">
                        <TextfieldComponent
                          type="text"
                          name="bankname"
                          value={this.state.bankname}
                          label="Enter Bank Name"
                          onChange={(e) => this.setState({ bankname: e.target.value })}
                          error={errors?.bankname}
                        />
                      </fieldset>
                      <fieldset className=" col-md-4">
                        <TextfieldComponent
                          className="form-control"
                          type="text"
                          name="branchname"
                          label="Enter Branch Name"
                          value={this.state.branchname}
                          onChange={(e) => this.setState({ branchname: e.target.value })}
                          error={errors?.branchname}
                        />
                      </fieldset>


                      <fieldset className=" col-md-4">
                        <TextfieldComponent
                          className="form-control"
                          type="text"
                          name="accname"
                          label="Enter Account Name"
                          value={this.state.accname}
                          onChange={(e) => this.setState({ accname: e.target.value })}
                          error={errors?.accname}
                        />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <TextfieldComponent
                          className="form-control"
                          type="text"
                          name="accno"
                          label="Enter Account Number"
                          value={this.state.accno}
                          onChange={(e) => this.setState({ accno: e.target.value })}
                          error={errors?.accno}
                        />
                      </fieldset>

                    </div>

                    {/* {this.state.loader === true ? ( */}
                    <button
                      className="UI-btn UI-btn-primary"
                      disabled={this.state.loader === true}
                      type="submit"
                    >
                      {this.state.loader === true ? (
                        <>
                          <Spinner animation="border" size="sm" />
                          &nbsp;{"Saving"}
                        </>
                      ) : (
                        "Save"
                      )}
                    </button>
                    {/* ) : (
                      <button
                        className="btn btn-sm hovbuttonColour"
                        type="submit"
                      >
                        <i className="fas fa-save mr-2" />
                        Save
                      </button>
                    )} */}
                    <Link as="button" className="UI-btn UI-btn-outline ml-1" to={{ pathname: "/bank" }}>Cancel</Link>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}
export default withRouter(Addbank);
